<div class="section-header justify-self-start w-full mb-3">
  <p class="p-0 mt-3 mb-3" id="ntrAndAge-header">{{ translationService.translate('ntrAndAgeText') }}</p>
  <mat-divider></mat-divider>
</div>

<div class="grid grid-rows-2 gap-2">
  <form [formGroup]="ntrFormGroup">
    <app-action-details
      id="ntrActionDetails"
      [limitTranslationKey]="'ntr'"
      [limitFormControlName]="'limit'"
      [id]="'ntr'"
      [limit]="ntr.limit"
      [formGroup]="ntrFormGroup"
      [editMode]="editMode"
      [isDefault]="isDefault"
    />
  </form>

  <form [formGroup]="ageFormGroup">
    <app-action-details
      id="ageActionDetails"
      [limitTranslationKey]="'ageMonths'"
      [limitFormControlName]="'limit'"
      [id]="'age'"
      [limit]="age.limit"
      [formGroup]="ageFormGroup"
      [editMode]="editMode"
      [isDefault]="isDefault"
    />
  </form>
</div>
